import { api } from "./api";

/**
 * SAAS-1 · 订阅版首页「经营助手」数据层（后端 routes/assistant.py；edition ≠ subscription 一律 404，企业版不会调用）。
 * 契约样稿：designs/mockups/theme/个人站订阅版-样稿.html ① 首页（tag saas-mockup-v1）。
 * 🔴 数字全部来自后端：待办格子的数字和「点进去的列表」同一个查询条件；没有数据来源的格子后端就不返回。
 */
export interface AssistantTodoItem {
  key: string;
  label: string;
  count: number;
  link: string;
  source: string;       // 一句话口径（数的是哪张表、什么条件、和哪个列表同源）
}
export interface AssistantTodoGroup {
  key: "orders" | "partners" | "ops" | string;
  label: string;
  items: AssistantTodoItem[];
}
export interface AssistantTodos {
  groups: AssistantTodoGroup[];
}

export interface AssistantCalendarDay {
  date: string;
  tours: number;        // 当天出发的团期数
  alerts: number;       // 当天未处理的调度问题 + 没指定司导的车次
}
export interface AssistantCalendar {
  month: string;
  days: AssistantCalendarDay[];
}

export interface StripItem {
  run_id: string;
  label: string;
  product_codes: string[];
  start_time: string | null;       // HH:MM；产品没填集合时间 = null（不编）
  day_no: number;                  // 车次的第几天
  multi_day: boolean;
  driver: { id: string; label: string; response?: string } | null;
  seats: number | null;
  pax: number;
  seat_tier: "ample" | "tight" | "full" | null;
  state: string;
  alerts: { key: string; label: string }[];
  link: string;
}
export interface StripLine {
  key: string;
  name: string;
  items: StripItem[];
}
export interface TodayStrip {
  date: string;
  lines: StripLine[];
  unattached: { order_id: string; order_no: string; date: string; pax: number; customer: string | null; reason: string }[];
  link: string;
}

export interface OrderStatsDay {
  date: string;
  count: number;
  amount_cents: number | null;     // 没有订单金额权限 = null
  s4_count: number;
}
export interface OrderStats {
  from: string;
  to: string;
  days: OrderStatsDay[];
  total_count: number;
  total_amount_cents: number | null;
  total_s4_count: number;
}

const q = (p: Record<string, string | undefined>) => {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) if (v) s.set(k, v);
  const t = s.toString();
  return t ? `?${t}` : "";
};

export const assistantApi = {
  todos: () => api<AssistantTodos>("/api/v1/assistant/todos"),
  calendar: (month: string) => api<AssistantCalendar>(`/api/v1/assistant/calendar${q({ month })}`),
  todayStrip: (date?: string) => api<TodayStrip>(`/api/v1/assistant/today-strip${q({ date })}`),
  orderStats: (from?: string, to?: string) => api<OrderStats>(`/api/v1/assistant/order-stats${q({ from, to })}`),
};

export const ASSISTANT_QK = ["assistant"] as const;
